export const GET_BAKED_BREADS = 'GET_BAKED_BREADS';
export const SUCCESS_GET_BAKED_BREADS = 'SUCCESS_GET_BAKED_BREADS';
export const FAIL_GET_BAKED_BREADS = 'FAIL_GET_BAKED_BREADS';

export const GET_RESERVATION_BAKED_BREADS = 'GET_RESERVATION_BAKED_BREADS';
export const SUCCESS_GET_RESERVATION_BAKED_BREADS = 'SUCCESS_GET_RESERVATION_BAKED_BREADS';
export const FAIL_GET_RESERVATION_BAKED_BREADS = 'FAIL_GET_RESERVATION_BAKED_BREADS';

export const GET_SHOP_BAKED_BREADS = 'GET_SHOP_BAKED_BREADS';
export const SUCCESS_GET_SHOP_BAKED_BREADS = 'SUCCESS_GET_SHOP_BAKED_BREADS';
export const FAIL_GET_SHOP_BAKED_BREADS = 'FAIL_GET_SHOP_BAKED_BREADS';

export const SET_DRAFT = 'SET_DRAFT';

export const SET_BAKED_BREADS_LIST_TYPE = 'SET_BAKED_BREADS_LIST_TYPE';

export const CREATE_BAKED_BREAD = 'CREATE_BAKED_BREAD';
export const SUCCESS_CREATE_BAKED_BREAD = 'SUCCESS_CREATE_BAKED_BREAD';
export const FAIL_CREATE_BAKED_BREAD = 'FAIL_CREATE_BAKED_BREAD';

export const UPDATE_BAKED_BREAD = 'UPDATE_BAKED_BREAD';
export const SUCCESS_UPDATE_BAKED_BREAD = 'SUCCESS_UPDATE_BAKED_BREAD';
export const FAIL_UPDATE_BAKED_BREAD = 'FAIL_UPDATE_BAKED_BREAD';

export const UPDATE_BAKED_BREAD_ORDERS = 'UPDATE_BAKED_BREAD_ORDERS';
export const SUCCESS_UPDATE_BAKED_BREAD_ORDERS = 'SUCCESS_UPDATE_BAKED_BREAD_ORDERS';
export const FAIL_UPDATE_BAKED_BREAD_ORDERS = 'FAIL_UPDATE_BAKED_BREAD_ORDERS';

export const INIT_BAKED_BREAD = 'INIT_BAKED_BREAD';
